import Header from "../../components/Header/LandingHeader";
import s from "./UpcomingNewsDetails.module.scss";
import { useSelector } from "react-redux";
import useWindowDimensions from "../../components/WindowDimentions/WindowDimentions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import PageTitle from "../../components/PageTitle/PageTitle";
import BackLink from "../../components/BackLink/BackLink";
import { useParams } from "react-router-dom";
import { FilePdfOutlined } from "@ant-design/icons";

// Содержимое каждой страницы редактируется отдельно
const pages = {
  moldova: {
    image: "/images/mld.png",
    content: (
      <>
        <PageTitle
          className={s.title}
          eyebrow="UPCOMING EVENTS"
          title={"1st Regional Forum and Workshop on the Middle Corridor"}
        />

        <div className={s.news_header}>
          {/* <div className={s.date}>{news?.created_at}</div> */}
        </div>
        <div className={s.news_description}>
          <p>
            The National Customs Association of Moldova and its affiliated body,
            the Middle Corridor Transit Advisory Committee (MCTAC), in
            cooperation with the German Agency for International Cooperation
            (GIZ), are planning to organize a series of Meetings and Workshops
            for MCTAC Partners in Europe, the Caspian Region, and Central Asia
            on the digitalization of transit procedures along the Middle
            Corridor."{" "}
          </p>{" "}
          <p>
            {" "}
            The main objective of these events is to present the Digital Transit
            HUB, a digital tool developed by the MCTAC team to facilitate and
            streamline transit procedures along the Middle Corridor.
          </p>
          <strong>
            The events will take place in Chisinau, Moldova on 18 November 2026
          </strong>
          <p></p>
          <p>
            The Meetings and Workshops are designed for business communities
            across all Middle Corridor countries, particularly companies and
            professionals actively involved in transit formalities and the
            processing of transit shipments in their respective countries. The
            events will focus on the business-to-business (B2B) dimension of
            cooperation and the practical application of digital solutions to
            facilitate transit operations.
          </p>
          <p>
            MCTAC partners from across the Middle Corridor countries will also
            participate in the workshops. Special business simulations and
            interactive exercises will be organized for regional MCTAC partners,
            allowing participants to practice the processing and clearance of
            goods and transport vehicles transiting through Middle Corridor
            countries.
          </p>
          <p>
            These events will provide a platform for sharing expertise,
            strengthening regional business cooperation, and promoting the
            digital transformation of transit procedures along the Middle
            Corridor.
          </p>
        </div>
      </>
    ),
  },
  baku: {
    image: "/images/баку.jpg",
    content: (
      <>
        <PageTitle
          className={s.title}
          eyebrow="UPCOMING EVENTS"
          title={"2nd Regional Forum and Workshop on the Middle Corridor"}
        />

        <div className={s.news_header}>
          {/* <div className={s.date}>{news?.created_at}</div> */}
        </div>
        <div className={s.news_description}>
          <p>
            The National Customs Association of Moldova and its affiliated body,
            the Middle Corridor Transit Advisory Committee (MCTAC), in
            cooperation with the German Agency for International Cooperation
            (GIZ), are planning to organize a series of Meetings and Workshops
            for MCTAC Partners in Europe, the Caspian Region, and Central Asia
            on the digitalization of transit procedures along the Middle
            Corridor."{" "}
          </p>{" "}
          <p>
            {" "}
            The main objective of these events is to present the Digital Transit
            HUB, a digital tool developed by the MCTAC team to facilitate and
            streamline transit procedures along the Middle Corridor.
          </p>
          <strong>
            The events will take place in Baku, Azerbaijan on 24 November 2026
          </strong>
          <p></p>
          <p>
            The Meetings and Workshops are designed for business communities
            across all Middle Corridor countries, particularly companies and
            professionals actively involved in transit formalities and the
            processing of transit shipments in their respective countries. The
            events will focus on the business-to-business (B2B) dimension of
            cooperation and the practical application of digital solutions to
            facilitate transit operations.
          </p>
          <p>
            MCTAC partners from across the Middle Corridor countries will also
            participate in the workshops. Special business simulations and
            interactive exercises will be organized for regional MCTAC partners,
            allowing participants to practice the processing and clearance of
            goods and transport vehicles transiting through Middle Corridor
            countries.
          </p>
          <p>
            These events will provide a platform for sharing expertise,
            strengthening regional business cooperation, and promoting the
            digital transformation of transit procedures along the Middle
            Corridor.
          </p>
        </div>
      </>
    ),
  },
};

const defaultPage = pages.moldova;

const UpcomingNewsDetails = () => {
  const { city } = useParams();
  const page = pages[city] || defaultPage;
  const news = useSelector((state) => state.landing.newsDetails);
  const { width } = useWindowDimensions();

  return (
    <div>
      {width > 1200 ? (
        <div className={s.header_wrapper}>
          <Header />
        </div>
      ) : (
        <MobileHeader />
      )}
      <div className={s.content}>
        <BackLink fallback="/news" className={s.back}>
          Back
        </BackLink>
        <div className={s.news_img}>
          <img
            src={page.image}
            alt="MCTAC international conference"
            className={s.img}
          />
        </div>
        {page.content}
        <div className={s.link}>
          <FilePdfOutlined className={s.meta_icon} /> Program of the conference
          is{" "}
          <a
            href={"#"}
            target="_blank"
            rel="noopener noreferrer"
            className={s.link_text}
          >
            here
          </a>
          .
        </div>
      </div>
      <LandingFooter />
    </div>
  );
};

export default UpcomingNewsDetails;
